import React, { useEffect, useState } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import TableList from '../../layout/TableList';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listAudienceCategoriesAction, editAudienceCategoriesAction, deleteAudienceCategoriesAction } from '../../../actions/audienceCategoriesActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import { Spinner } from 'react-bootstrap';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR } from '../../../data/objects';
import AuthoritiesService from '../../../services/AuthoritiesService';
import QuickFilter from '../../layout/QuickFilter';
//Función principal
const AudienceCategoryList = props => {
    const params = {
        sort: 'descripcion:asc'
    }
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const audienceCategoriesLoading = useSelector( state => state.audienceCategories.loading );
    const audienceCategories = useSelector( state => state.audienceCategories.audienceCategories );
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [ data, setData ] = useState(null);
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editAudienceCategoriesAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteAudienceCategoriesAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Descripción',
            width: null,
            style: null,
            field: 'descripcion'
        },
        {
            name: 'Grupo',
            width: null,
            style: null,
            field: 'grupo',
            subfield: 'descripcion'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Verifico si hay datos
        if(audienceCategories){
            //Seteo los datos
            setData(audienceCategories.filter(item => item.grupo && true));
        }else{
            //Si no hay datos, debo cargarlo
            dispatch( listAudienceCategoriesAction(params) );
        }
    }, [audienceCategories]);
    
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            initialData={audienceCategories && audienceCategories.filter(item => item.grupo && true)}
                            headers={headers}
                            setData={setData}
                        />
                        {
                            audienceCategoriesLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            data ? (
                                <TableList
                                    prefix="ac"
                                    headers={headers}
                                    items={data}
                                    state={{
                                        field: 'activo',
                                        disabledClass: 'table-danger',
                                        disabledValue: 0,
                                        hideActions: true
                                    }}
                                />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudienceCategoryList;